(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('project-type', {
            parent: 'entity',
            url: '/project-type',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.projectType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-type/project-types.html',
                    controller: 'ProjectTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'update_date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('project-type-detail', {
            parent: 'project-type',
            url: '/project-type/{id}',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.projectType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-type/project-type-detail.html',
                    controller: 'ProjectTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProjectType', function($stateParams, ProjectType) {
                    return ProjectType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'project-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        
        .state('project-type.new', {
            parent: 'project-type',
            url: '/create',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
			views:{
				'content@':{
					templateUrl: 'app/entities/project-type/project-type-dialog.html',
                    controller: 'ProjectTypeDialogController',
                    controllerAs: 'vm'
				}
			},
			resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                createdDate: null,
                                updateDate: null,
                                id: null
                            };
                        }
                    }
        })
		.state('project-type.edit', {
            parent: 'project-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ENTITY_CONFIGURATION'],
                pageTitle: 'trakeyeApp.projectType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-type/project-type-dialog.html',
                    controller: 'ProjectTypeDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProjectType', function($stateParams, ProjectType) {
                    return ProjectType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'project-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
      
        .state('project-type.delete', {
            parent: 'project-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ENTITY_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-type/project-type-delete-dialog.html',
                    controller: 'ProjectTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'sm',
                    resolve: {
                        entity: ['ProjectType', function(ProjectType) {
                            return ProjectType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-type', null, { reload: 'project-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
